import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { BaseError } from '../../helpers/BaseError';

import { TestMessageResultsResponse } from '../../models/formula.model';

import API from '../../services/api';

import formulaKeys from './_queryKeys';

interface UseTestMessageResultsQueryOptions {
    enabled?: boolean;
    refetchInterval?: number | false;
}

const useTestMessageResultsQuery = (
    requestId: string | undefined,
    options: UseTestMessageResultsQueryOptions = {},
) => {
    return useQuery<AxiosResponse<TestMessageResultsResponse>, BaseError>({
        queryKey: formulaKeys.testMessageResults(requestId ?? ''),
        queryFn: () => API.getTestMessageResults(requestId as string),
        enabled: !!requestId && (options.enabled ?? true),
        refetchInterval: options.refetchInterval,
        retry: false,
        meta: { skipGlobalErrorToast: true },
    });
};

export default useTestMessageResultsQuery;
